export default __webpack_public_path__ + "static/media/logo.d53ed178.jpg";